import { httpRequest } from "@services/http"

export class CommandDeleteAudienceNetworkPolicy {
  async run(launchId: number, adGroupId: number, network: string): Promise<void> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/policies`
    // The backend deletes a budget policy by its id, but the budget tree only
    // surfaces `has_explicit_policy` (no id). The network lives on the policy's
    // scope (scope_type "NETWORK"), so resolve the id for this network, then delete.
    const policies = await httpRequest<any[]>(`${base}/`, { method: "GET" })
    const target = (policies ?? []).find((p) =>
      (p.scopes ?? []).some(
        (s: any) => s.scope_type === "NETWORK" && s.scope_key === network.toUpperCase(),
      ),
    )
    if (!target) return
    await httpRequest(`${base}/budget/${target.id}/`, { method: "DELETE" })
  }
}
